import type { ReactElement } from "react";

export function SuccessFilledIcon(): ReactElement {
  return (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.6846 49.2234L52.5233 28.3846L49.0501 24.9114L31.6846 42.2768L22.9846 33.5768L19.5113 37.0501L31.6846 49.2234ZM36.0098 65.4001C31.9443 65.4001 28.1221 64.6286 24.5431 63.0856C20.9646 61.5426 17.8516 59.4486 15.2041 56.8036C12.5566 54.1586 10.4608 51.0481 8.91685 47.4721C7.37235 43.8966 6.6001 40.0758 6.6001 36.0098C6.6001 31.9318 7.3731 28.0976 8.9191 24.5071C10.4651 20.9171 12.5631 17.7943 15.2131 15.1388C17.8631 12.4828 20.9736 10.3958 24.5446 8.87785C28.1151 7.35935 31.9303 6.6001 35.9903 6.6001C40.0678 6.6001 43.9016 7.3586 47.4916 8.8756C51.0811 10.3926 54.2041 12.4781 56.8606 15.1321C59.5171 17.7861 61.6044 20.9071 63.1223 24.4951C64.6409 28.0831 65.4001 31.9168 65.4001 35.9963C65.4001 40.0759 64.6416 43.8966 63.1246 47.4586C61.6076 51.0201 59.5224 54.1271 56.8689 56.7796C54.2154 59.4321 51.0951 61.5321 47.5081 63.0796C43.9211 64.6266 40.0883 65.4001 36.0098 65.4001Z"
        fill="#128351"
      />
    </svg>
  );
}
